var map = {
	"./anqara/img.png": 5650,
	"./anqara/img_1.png": 2770,
	"./balx/img.png": 125,
	"./balx/img_1.png": 2553,
	"./bogdod/img.png": 2386,
	"./buxoro/img.png": 6343,
	"./buxoro/img_1.png": 6194,
	"./dehli/img.png": 2417,
	"./dehli/img_1.png": 3751,
	"./dehli/img_2.png": 315,
	"./halab/img.png": 5664,
	"./halab/img_1.png": 3881,
	"./hirot/img.png": 8257,
	"./hirot/img_1.png": 6986,
	"./img_1.png": 4762,
	"./img_2.png": 9359,
	"./img_3.png": 5256,
	"./img_4.png": 8090,
	"./isfaxon/img.png": 3791,
	"./isfaxon/img_1.png": 8311,
	"./isfaxon/img_2.png": 121,
	"./kesh.jpg": 2971,
	"./qunduz/img.png": 392,
	"./qunduz/img_1.png": 9273,
	"./sheroz/img.png": 3432,
	"./sheroz/img_1.png": 4371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;